/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useImmer } from "use-immer";
import { usePermission, useTabs } from "../../../shared";
import { AppContext } from "../../../store/AppScopeProvider";
import { errorMessage, getStoreId, successMessage } from "../../../utils";
import moment from "moment";
import {
  assignCustomersToClinetAccount,
  createClientAccount,
  createClinetAccountSettlement,
  downloadTransactionDetailsPDF,
  getClientAccountsList,
  getClientAccountTransactionDetailsApi,
  getClientAccountTransactionsListApi,
  getPurchasedData,
  revertPaymentApi,
  sendInvoiceApi,
  sendInvoiceApibyID,
  sendTransactionEmailApi,
} from "../api";
import {
  createCustomer,
  deleteClientAccountById,
  EnableOrDisableClientAccount,
  getClientAccountDetailsById,
  getCustomersList,
} from "../../Customers";
import qs from "qs";
import { useDebounce, useDebouncedCallback } from "use-debounce";
import { AuthContext } from "../../../store/AuthProvider";
import { TableStateContext } from "../../../store";
import { set } from "date-fns";
import fileDownload from "js-file-download";

export const useClientAccountTransactions = ({ id, isList, tId }) => {
  const { appState } = useContext(AppContext);
  const storeId = getStoreId();
  const { auth } = useContext(AuthContext);
  const { setCurentTab } = useTabs();
  const isEditable = usePermission("client-account-modify");
  const isDeletable = usePermission("client-account-delete");
  const isCreateVisible = usePermission("client-account-create");
  const {
    globalData,
    currentTabs: { clientAccDetails: currentTab },
  } = appState;
  const { pathname } = useLocation();
  const isStoreAdmin = pathname.includes("store-admin");
  const isCustomer = pathname.includes("customers");

  const navigate = useNavigate();

  const [selectedRows, setSelectedRows] = React.useState([]);
  const [state, setState] = useImmer({
    initialLoad: true,
    dataList: [],
    isLoading: false,
    openSendInvoiceDialog: false,
    filter: {
      date: null,
      transactionType: "",
      search: "",
      filterApplied: true,
    },
    date: [
      {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
    ],
    showDate: [],
    isCalenderOpen: false,
    transactionTypes: [
      { label: "Purchase", value: 1 },
      { label: "Refund", value: 2 },
    ],
    selectedTransactions: [],
    details: {},
    openSendEmaileDialog: false,
    isOpenRevertPayment: false,
    revertPayment: {
      reason: "",
      files: [],
    },
    revertLoading: false,
  });

  const handleClientAccountTransactionsList = async ({
    transactionType = "",
    search = "",
    date = [],
  }
  ) => {
    try {
      setState((draft) => {
        draft.isLoading = true;
      });

      let params = {};

      if (search) {
        params = { ...params, search };
      }

      if (transactionType) {
        params = { ...params, transaction_type: transactionType };
      }

      if (date?.length) {
        params = {
          ...params,
          start_date: moment(date[0].startDate).format("YYYY-MM-DD"),
          end_date: moment(date[0].endDate).format("YYYY-MM-DD"),
        };
      }
      const query = {
        params,
        paramsSerializer: (params) => qs.stringify(params),
      };
      const res = await getClientAccountTransactionsListApi(id, query);
      if (res.success) {
        setState((draft) => {
          draft.dataList = res.data;
          draft.isLoading = false;
        });
      }
    } catch (err) {
      console.log(err);

      errorMessage(err.response.data.message);
      setState((draft) => {
        draft.isLoading = false;
      });
    }
  };

  useEffect(() => {
    if (isList) {
      handleClientAccountTransactionsList({})
    }
  }, [isList])


  const handleGetSelectedRows = (checked, rows) => {
    if (checked) {
      setState((draft) => {
        draft.selectedTransactions.push(rows.id);
      });
    } else {
      setState((draft) => {
        draft.selectedTransactions = draft.selectedTransactions.filter((item) => item !== rows.id);
      });
    }
  }

  //handle send invoice modal
  const handleModal = (type, value) => {
    if (type === "sendInvoice") {
      setState((draft) => {
        draft.openSendInvoiceDialog = value;
      });
    }
    if (type === "email") {
      setState((draft) => {
        draft.openSendEmaileDialog = value;
      });
    }
    if (type === "revert") {
      setState((draft) => {
        draft.isOpenRevertPayment = value;
      });
    }
  }

  //handle send invoice form submit
  const handleSendInvoice = async (email) => {
    try {

      let payload = {
        transactions: state.selectedTransactions,
        emails: email,
      }

      const res = await sendInvoiceApi(payload);
      if (res.success) {
        successMessage(res.message);
        setState((draft) => {
          draft.openSendInvoiceDialog = false;
        });
      } else {
        errorMessage(res.message);
      }
    } catch (err) {
      errorMessage(err.response.data.message);
    }
  }

  //handle send invoice form submit
  const handleSendInvoiceByID = async (email) => {
    try {

      let payload = {
        emails: email,
      }

      const res = await sendInvoiceApibyID(id, tId, payload);
      if (res.success) {
        successMessage(res.message);
        setState((draft) => {
          draft.openSendEmaileDialog = false;
        });
      } else {
        errorMessage(res.message);
      }
    } catch (err) {
      errorMessage(err.response.data.message);
    }
  }

  //function for handle filter transaticon type and date range
  const handleFilter = (value, type) => {
    console.log(value, type);

    if (type === "transactionType") {
      setState((draft) => {
        draft.filter.transactionType = value;
      });
    } else if (type === "date") {
      setState((draft) => {
        draft.filter.date.value = value;
      });
    }
  };

  //handle search function
  const handleSearch = (value) => {
    setState((draft) => {
      draft.filter.search = value;
    });
    // debounced(value)
  }

  //handle clear search
  const onSeachClear = () => {
    setState((draft) => {
      draft.filter.search = "";
    });
    // debounced("")
  }

  const handleDateChangeApply = () => {
    console.log(state.date);

    setState((draft) => {
      draft.showDate = state.date;
      draft.isCalenderOpen = false;
      draft.filter.date = state.date;
    });
  };
  const onChangeDate = (e) => {
    setState((draft) => {
      draft.date = e;
    });
  };
  const handleIsOpen = (e) => {
    setState((draft) => {
      draft.isCalenderOpen = e;
    });
  };

  const resetFilters = () => {
    setState((draft) => {
      draft.filter = {
        date: null,
        transactionType: "",
        search: "",
        filterApplied: false,
      };
      draft.date = [
        {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
      ];
      draft.showDate = [];
      draft.isCalenderOpen = false;
    });
    handleClientAccountTransactionsList({});
  };

  //handle appy filter function
  const handleApplyFilter = () => {
    try {
      const { transactionType, date, search } = state.filter;
      console.log(date);

      handleClientAccountTransactionsList({
        search,
        transactionType,
        date,
      });
      setState((draft) => {
        draft.filter.filterApplied = true;
      });
    } catch (error) {
      console.log(error);

    }

  };

  useEffect(() => {
    if (tId) {
      handleClientAccountTransactionsDetails(tId);
    }

  }, [tId])


  const handleClientAccountTransactionsDetails = async (tId) => {

    try {
      setState((draft) => {
        draft.isLoading = true;
      });
      const res = await getClientAccountTransactionDetailsApi(tId);
      if (res.success) {
        setState((draft) => {
          draft.isLoading = false;
          draft.details = res.data;
        });
      } else {
        errorMessage(res.message);
        setState((draft) => {
          draft.isLoading = false;
        });
      }
    }
    catch (err) {
      errorMessage(err.response.data.message);
      setState((draft) => {
        draft.isLoading = false;
      });
    }
  }

  const handleDownloadPDF = async (type = "") => {
    try {
      const res = await downloadTransactionDetailsPDF(id, tId);
      const content = res.headers["content-type"];

      if (type === "print") {
        printFile(res.data);
      } else {
        fileDownload(res.data, `settlement.pdf`, content);;
      }
    } catch (error) {
      errorMessage(error.response.data.message);
    }
  }

  const printFile = (blob) => {
    let blobURL = URL.createObjectURL(blob);
    let iframe = document.createElement("iframe"); //load content in an iframe to print later
    document.body.appendChild(iframe);
    iframe.style.display = "none";
    iframe.src = blobURL;
    iframe.onload = function () {
      setTimeout(function () {
        iframe.focus();
        iframe.contentWindow.print();
      }, 1);
    };
  };

  const handleSendEmail = async (email) => {
    try {

      let payload = {
        emails: email,
      }

      const res = await sendTransactionEmailApi(payload);
      if (res.success) {
        successMessage(res.message);
        setState((draft) => {
          draft.openSendEmaileDialog = false;
        });
      } else {
        errorMessage(res.message);
      }
    } catch (err) {
      errorMessage(err.response.data.message);
    }
  }

  const handleFileChange = (event) => {
    const files = Array.from(event?.target?.files || []); // Converts FileList to array
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'];

    const validFiles = files.filter(file => allowedTypes.includes(file.type));

    if (validFiles.length !== files.length) {
      errorMessage('Only images (JPEG, PNG, GIF) and PDF files are allowed');
    }

    setState((draft) => {
      draft.revertPayment.files = [...draft.revertPayment.files, validFiles]
      draft.isFormUpdated = false;
    });
  };

  const handleInputChange = (event) => {
    setState((draft) => {
      draft.revertPayment.reason = event?.target?.value;
    });
  }

  const handleFileDelete = (index) => {
    setState((draft) => {
      draft.revertPayment.files = draft.revertPayment.files.filter((_, i) => i !== index);
    });
  };

  const handleSubmitRevertPayment = async () => {
    try {
      setState((draft) => {
        draft.isLoading = true;
      });

      const formData = new FormData();
      formData.append('reason', state.revertPayment.reason);

      // Handle multiple files with the correct field name
      state.revertPayment.files.flat().forEach(file => {
        formData.append('reverted_files[]', file);
      });

      const res = await revertPaymentApi(tId, formData);

      if (res.success) {
        successMessage(res.message);
        setState((draft) => {
          draft.revertLoading = false;
          draft.isOpenRevertPayment = false;
          draft.revertPayment = {
            reason: '',
            files: []
          };
        });
        // Refresh the transaction details
        await handleClientAccountTransactionsDetails(tId);
      } else {
        errorMessage(res.message);
        setState((draft) => {
          draft.revertLoading = false;
        });
      }
    } catch (err) {
      errorMessage(err.response?.data?.message || 'Something went wrong');
      setState((draft) => {
        draft.revertLoading = false;
      });
    }
  };

  const isCheckIndeterminate = (rows) => {

    let allItems = rows.filter((e, i) => {
      return e.original.transaction_type === 'Purchase';
    });

    let ids = state.selectedTransactions
    console.log(ids.length > 0 && ids.length < allItems.length);

    return ids.length > 0 && ids.length < allItems.length;
  };

  const isAllChecked = (rows) => {
    let allItems = rows.filter((e, i) => {
      return e.original.transaction_type === 'Purchase';
    });
    let ids = state.selectedTransactions

    return ids.length === allItems.length;
  };

  const handleCheckAll = (checked, rows) => {
    if (checked) {
      let allItems = rows.filter((e, i) => {
        return e.original.transaction_type === 'Purchase';
      });
      let ids = allItems.map((e, i) => {
        return e.original.id;
      });
      setState((draft) => {
        draft.selectedTransactions = ids;
      });
    } else {
      setState((draft) => {
        draft.selectedTransactions = [];
      });
    }
  }
  return {
    state,
    isStoreAdmin,
    navigate,
    handleGetSelectedRows,
    handleModal,
    handleSendInvoice,
    handleFilter,
    handleSearch,
    onSeachClear,
    handleDateChangeApply,
    onChangeDate,
    handleIsOpen,
    resetFilters,
    handleApplyFilter,
    handleDownloadPDF,
    handleSendEmail,
    handleSendInvoice,
    handleInputChange,
    handleFileChange,
    handleSubmitRevertPayment,
    handleSendInvoiceByID,
    isCheckIndeterminate,
    isAllChecked,
    handleCheckAll,
    handleFileDelete,
  };
};
